module.exports = __webpack_public_path__ + "static/media/curtiss_sarikey.948cace2.png";